import { render, staticRenderFns } from "./ProductsOverview.vue?vue&type=template&id=fbde42e6&"
import script from "./ProductsOverview.vue?vue&type=script&lang=js&"
export * from "./ProductsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports